import useDocumentMeta from "@/hooks/useDocumentMeta";
import { Link } from "react-router-dom";
import { ACCOMMODATIONS } from "@/lib/site";

const SECTIONS = [
  {
    heading: "Main pages",
    links: [
      { to: "/", label: "Home" },
      { to: "/accommodation", label: "Accommodation — cabins, caravan sites & camping" },
      { to: "/amenities", label: "Park amenities" },
      { to: "/gallery", label: "Photo gallery" },
      { to: "/about", label: "About Shady Acres" },
      { to: "/contact", label: "Contact & enquiries" },
      { to: "/book", label: "Book a stay" },
    ],
  },
  {
    heading: "Policies & legal",
    links: [
      { to: "/policies#cancellation", label: "Cancellation policy" },
      { to: "/policies#pet", label: "Pet policy" },
      { to: "/policies#other", label: "Other rates & information" },
      { to: "/policies#terms", label: "Terms & Conditions" },
      { to: "/policies#privacy", label: "Privacy Policy" },
    ],
  },
];

export default function SitemapPage() {
  useDocumentMeta();
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-32" data-testid="sitemap-page">
      <div className="overline">Every page, one screen</div>
      <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[0.95] mt-4 max-w-4xl">
        Sitemap
      </h1>
      <p className="mt-6 text-sa-ink2 text-lg max-w-2xl">
        A quick index of everything on this site. Looking for the machine-readable version? It&apos;s at{" "}
        <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer" className="text-sa-accent hover:underline" data-testid="sitemap-xml-link">/sitemap.xml</a>.
      </p>

      <div className="mt-16 grid md:grid-cols-2 gap-12">
        {SECTIONS.map((s) => (
          <div key={s.heading} data-testid={`sitemap-section-${s.heading.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <div className="overline text-sa-accent">{s.heading}</div>
            <ul className="mt-5 space-y-3 text-[15.5px]">
              {s.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sa-ink hover:text-sa-accent border-b border-sa-ink/10 hover:border-sa-accent pb-1 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div data-testid="sitemap-section-stay-types">
          <div className="overline text-sa-accent">Stay types</div>
          <ul className="mt-5 space-y-3 text-[15.5px]">
            {ACCOMMODATIONS.map((a) => (
              <li key={a.id}>
                <Link
                  to={`/book?package=${a.id}`}
                  className="text-sa-ink hover:text-sa-accent border-b border-sa-ink/10 hover:border-sa-accent pb-1 transition-colors"
                >
                  {a.name} — from ${a.price_from}/night
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
